import { GroupMember } from "@/src/models/user.model";
import { GroupMemberTab, PagyMeta } from "@/src/screens/groups/group-members";
import { useGetGroupMembers } from "@/src/services/api/groups/groups.hooks";
import { useState } from "react";
import { formatUserName } from "@/src/utils/string.utils";

export const useGroupMembersTable = (
  groupId: string,
  initialMembersTab?: string, // new param
) => {
  // Auto-activate Pending tab when coming from join_request notification
  const [active, setActive] = useState<GroupMemberTab>(
    initialMembersTab === "pending"
      ? GroupMemberTab.PENDING
      : GroupMemberTab.ALL_MEMBERS,
  );

  // Members
  const [membersPage, setMembersPage] = useState(1);
  const { data, isPending, isError } = useGetGroupMembers(groupId, membersPage);

  const members: GroupMember[] = (data?.getgroupmemberships?.items ?? []).map(
    (item: any) => ({
      itemId: item.ItemId,
      userId: item.userId,
      firstName: item.groupUserSnapshot.firstName,
      lastName: item.groupUserSnapshot.lastName,
      displayName: formatUserName(
        item.groupUserSnapshot.firstName,
        item.groupUserSnapshot.lastName,
      ),
      email: item.groupUserSnapshot.email,
      role: item.role,
      status: item.status,
      profileImageUrl: item.groupUserSnapshot.profileImageUrl ?? null,
      joinedAt: item.joinedAt,
    }),
  );

  const membersPagy: PagyMeta | undefined = data?.getgroupmemberships
    ? {
        current_page: membersPage,
        total_pages: data.getgroupmemberships.totalPages,
        total_count: data.getgroupmemberships.totalCount,
        from: (membersPage - 1) * 10 + 1,
        to: Math.min(membersPage * 10, data.getgroupmemberships.totalCount),
      }
    : undefined;

  // Confirm Modal
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState<GroupMember | null>(
    null,
  );
  const [actionType, setActionType] = useState<ActionType | null>(null);

  const openConfirm = (member: GroupMember, type: ActionType) => {
    setSelectedMember(member);
    setActionType(type);
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    if (!selectedMember || !actionType) return;
    // TO-DO: Button handlers
    setConfirmOpen(false);
    setSelectedMember(null);
    setActionType(null);
  };

  const handleCancel = () => setConfirmOpen(false);

  return {
    active,
    setActive,

    members,
    membersPagy,
    setMembersPage,
    isPending,
    isError,

    confirmOpen,
    setConfirmOpen,
    actionType,
    openConfirm,
    handleConfirm,
    handleCancel,
  };
};
